const module = { name: 'fd-location/form/events', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { fd_location_utils as fd_location_utils_getLocation_parseUserLocationCookie_updateLocation } from 'require-global';

const { getLocation, parseUserLocationCookie, updateLocation } = fd_location_utils_getLocation_parseUserLocationCookie_updateLocation;


import { fd_location_alertBox as alertBox } from 'require-global';



import { default as countrySwitcher } from 'swug-fdRequire-call:fd-location/countrySwitcher';



import { Fandango as Fandango } from 'require-core';



import { Fandango_cookie as Fandango_cookie_get_getCookie } from 'require-core';

const { get: getCookie } = Fandango_cookie_get_getCookie;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_eventQueue as eventQueue } from 'require-global';



const { EventNames } = eventQueue


import { Fandango_geolocator as geolocator } from 'require-global';



import { Fandango_localStore as localStore } from 'require-core';



import { Fandango_util as util } from 'require-global';



const { dtmData, isMobile, locationParams, pageDetails } = readPageContext(Fandango)


let modal


const Selectors = {
    CURRENT_LOCATION_BTN: '#useCurrentLocationBtn',
    CURRENT_LOCATION_TEXT: '#useCurrentLocationText',
    LOCATION_CANCEL: '.js-location-overlay-cancel',
    LOCATION_INPUT: '#setLocationSearchInput',
    LOCATION_FORM: '#locationForm',
    NAV_SEARCH_BTN: '#setLocationSearchBtn',
    PAST_LOCATION: '.js-past-location',
    RECENT_LOCATIONS: '#recentLocationsList',
}


const ErrorMsgs = {
    INVALID_INPUT: 'Please enter a valid location',
    TRY_AGAIN: 'Please try again, or enter a location below',
    GEOCODING_TIMEOUT: 'Sorry, we cannot manually set this location right now'
}


const ErrorCodes = {
    MANUAL_SET_LOCATION_FAILED: 14,
    AUTO_LOCATE_FAILED: 15,
    GEOCODING_TIMEOUT: 21
}


const CookieNames = {
    USER_LOCATION: 'userlocation'
}


const GOECODER_TIMEOUT = 11 * 1000


const MAX_LOCATION_AGE = 1000 * 60 * 60 * 24 * 365


const MAX_LOCATIONS = 6


const SUPPORTED_COUNTRIES = ['GB', 'IE', 'US']


let geocodeTimeoutId


let $inputField


let recentLocationsList
function readPageContext(Fandango) {
    const { dtmData, context: { device: { isMobile } }, locationParams, pageDetails } = Fandango;
    return {
        dtmData: dtmData || {},
        isMobile,
        locationParams: locationParams || {},
        pageDetails: pageDetails || {}
    };
}
function onTimerDone() {
    geocodeTimeoutId = null;
    onManualSetLocationDone(ErrorCodes.GEOCODING_TIMEOUT, null);
}
function startTimer() {
    if (!geocodeTimeoutId) {
        geocodeTimeoutId = window.setTimeout(onTimerDone, GOECODER_TIMEOUT);
    }
}
function stopTimer() {
    if (geocodeTimeoutId) {
        window.clearTimeout(geocodeTimeoutId);
        geocodeTimeoutId = null;
    }
}
function showError(error) {
    const { message } = error || {};
    debugLog.warn('account | set location', message || '');
    track({
        event: EventTypes.LOCATION_ERROR,
        errorMessage: message || ''
    });
    alertBox.showError(ErrorMsgs.TRY_AGAIN);
}
function toDisplayLocation(data = {}) {
    const city = data.city || '';
    const region = data.region || '';
    return `${city}${city && region ? ', ' : ''}${region}`;
}
function toLocationString(data) {
    const postal = data.postal || null;
    return postal || toDisplayLocation(data);
}
function updateLocationHistory(result) {
    const newLocation = toLocationString(result);
    if (!newLocation) {
        return;
    }
    const localList = localStore.get('search', 'searchLocationHistory');
    if (Array.isArray(localList) && localList.length) {
        recentLocationsList = Array.from(localList);
    }
    let list = (recentLocationsList || [])
        .filter(value => value !== newLocation);
    list.unshift(newLocation);
    list = list.slice(0, MAX_LOCATIONS);
    localStore.set('search', 'searchLocationHistory', list, {
        ttl: MAX_LOCATION_AGE
    });
}
function updateLocationName(opts = {}) {
    const postal = opts.postalCode || opts.zip;
    const location = postal
        ? { postalCode: postal, zip: postal, zipCode: postal, params: { postalCode: postal, zip: postal, zipCode: postal } }
        : getLocation();
    updateLocation(location);
    Object.assign(pageDetails, {
        location
    });
}
function exit(result, locationUpdated) {
    if (!isMobile && locationUpdated) {
        return eventQueue.emit(EventNames.LOCATION_DROPDOWN_CLOSE);
    }
    if (!modal) {
        return window.location = locationParams.from || '/';
    }
    if (locationUpdated) {
        modal.close();
        eventQueue.emit(EventNames.LOCATION_OVERLAY_CLOSE, result);
    }
}
function onCancelClick() {
    exit(null, null);
}
function onAutoLocateDone(err, result) {
    alertBox.setBusy(false);
    if (err || !result) {
        return showError(err || ErrorCodes.AUTO_LOCATE_FAILED);
    }
    if (result.mismatch) {
        return;
    }
    const userLocation = result.userlocation;
    updateLocationHistory(userLocation);
    const postal = userLocation.postal;
    track({
        event: EventTypes.USE_CURRENT_LOCATION,
        zipCode: postal,
        cityState: toDisplayLocation(userLocation),
    });
    $(Selectors.CURRENT_LOCATION_TEXT).html(toDisplayLocation(userLocation));
    $inputField.val(null);
    exit(result, true);
}
function doAutoLocate() {
    if (alertBox.isBusy()) {
        return;
    }
    alertBox.setBusy(true);
    alertBox.hideError();
    if (!navigator.geolocation) {
        alertBox.setBusy(false);
        return showError(ErrorCodes.AUTO_LOCATE_FAILED);
    }
    navigator.geolocation.getCurrentPosition((position) => {
        geolocator.setUserLocationCookie(position, onAutoLocateDone, {
            supportedCountries: SUPPORTED_COUNTRIES,
            defaultCountry: countrySwitcher.getCurrentCountry(),
        });
    }, () => {
        alertBox.setBusy(false);
        showError(ErrorCodes.AUTO_LOCATE_FAILED);
    }, { timeout: 10000 });
}
function finalizeLocation(result) {
    updateLocationHistory(result);
    const postal = result.postal || null;
    dtmData.zipCode = postal || dtmData.zipCode;
    if (postal) {
        track({ event: EventTypes.ZIP_CODE_ENTERED, zipCode: postal });
    }
    else {
        track({
            event: EventTypes.CITY_STATE_ENTERED,
            cityState: toDisplayLocation(result)
        });
    }
    $inputField.val(null);
    exit(result, true);
}
function onManualSetLocationDone(err, result) {
    stopTimer();
    alertBox.setBusy(false);
    if (err || !result) {
        debugLog.warn('account | set location', err || ErrorCodes.MANUAL_SET_LOCATION_FAILED);
        return alertBox.showError(err === ErrorCodes.GEOCODING_TIMEOUT ? ErrorMsgs.GEOCODING_TIMEOUT : ErrorMsgs.INVALID_INPUT);
    }
    if (result.mismatch) {
        return;
    }
    finalizeLocation(result.userlocation);
}
function doManualSetLocation(location) {
    if (alertBox.isBusy()) {
        return;
    }
    if (!location) {
        return alertBox.showError(ErrorMsgs.INVALID_INPUT);
    }
    alertBox.setBusy(true);
    startTimer();
    geolocator.setUserLocationCookie(location, onManualSetLocationDone, {
        supportedCountries: SUPPORTED_COUNTRIES,
        defaultCountry: countrySwitcher.getCurrentCountry(),
    });
}
function onFormSubmit(e) {
    if ($inputField.val()) {
        alertBox.hideError();
    }
    e.preventDefault();
    doManualSetLocation($inputField.val());
}
function onPastLocationClick(e) {
    e.preventDefault();
    const pastLocation = $(this).data('location');
    if (pastLocation) {
        alertBox.hideError();
    }
    doManualSetLocation(String(pastLocation));
}
function setLocations() {
    const list = localStore.get('search', 'searchLocationHistory');
    if (Array.isArray(list) && list.length >= 1) {
        recentLocationsList = Array.from(list);
        const markup = (swig.render('_searchedLocations', {
            locations: list.splice(1),
            isMobile
        }));
        $(Selectors.RECENT_LOCATIONS).html(markup);
        return $inputField.val(recentLocationsList[0]);
    }
    const userLocation = parseUserLocationCookie(getCookie(CookieNames.USER_LOCATION));
    const name = toDisplayLocation({ city: userLocation.city || null, region: userLocation.region || null });
    if (name && name !== '') {
        $inputField.val(name);
    }
}
function init(modalObj) {
    modal = modalObj;
    $(Selectors.LOCATION_CANCEL).on('click', onCancelClick);
    $(Selectors.CURRENT_LOCATION_BTN).on('click', doAutoLocate);
    $(Selectors.LOCATION_FORM).on('submit', onFormSubmit);
    $(Selectors.NAV_SEARCH_BTN).on('click', onFormSubmit);
    $inputField = $(Selectors.LOCATION_INPUT);
    if (locationParams.location) {
        $inputField.val(locationParams.location);
        doManualSetLocation($inputField.val());
    }
    setLocations();
    $(Selectors.PAST_LOCATION).on('click', onPastLocationClick);
    if (isMobile) {
        track({
            event: EventTypes.PAGE_VIEW,
            pageName: 'account | set location',
            pageType: 'set location',
            server: 'fandango mobile web discovery',
            platform: 'fandango mobile web'
        });
    }
    else {
        track({
            event: EventTypes.ZIP_CODE_DROPDOWN_LOAD,
        });
        util.track('set location', {
            pageName: 'myfdo | set location'
        });
    }
}
module.exports = {
    init,
    updateLocationHistory,
    updateLocationName
};
export default module.exports;